import { useMemo } from "react";
import { usePermissions } from "../providers/authProvider";
import { ART_LIST_URL, ORDER_LIST_URL } from "../config";

export type NavItem = { href: string; text: string; isActive?: boolean };
export const nav = [] as NavItem[];
const adminNav = [
  {
    text: "Gallery",
    href: "/art",
    isActive: true,
  },
  { href: ART_LIST_URL(undefined, true), text: "Art management", isActive: true },
  { href: ORDER_LIST_URL(undefined, true), text: "Order management", isActive: true },
];

export const useNav = () => {
  const userPermissions = usePermissions();
  const navItems = useMemo(() => {
    return [
      ...nav,
      ...(userPermissions?.data?.user?.admin ? [...adminNav] : []),
    ];
  }, [userPermissions?.data?.user?.admin]);
  return navItems;
};
